// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as SMSListApiModal from "../api-model/SMSListApiModal.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(SMSListApiModal.t_decode(json), "SmsMessageEntityMapper.res");
  return List.map((function (reasonData) {
                return {
                        phone_number: reasonData.phone_number,
                        message: reasonData.message,
                        status: reasonData.status,
                        order_id: reasonData.order_id,
                        created_at: reasonData.created_at,
                        status_details: reasonData.status_details,
                        sms_id: reasonData.sms_id
                      };
              }), res.message_details);
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
